import { HTTP } from '../../http-common'

export default {
  state: {
    loadedNuclei2: []
  },
  getters: {
    loadedNuclei2 (state) {
      return state.loadedNuclei2
    }
  },
  mutations: {
    setLoadedNuclei2 (state, payload) {
      state.loadedNuclei2 = payload
    },
    createNucleus2 (state, payload) {
      state.loadedNuclei2.push(payload)
    },
    updateNucleus2 (state, payload) {
      state.loadedNuclei2 = state.loadedNuclei2.map(nucleus => nucleus.id === payload.id ? payload : nucleus)
    },
    removeNucleus2 (state, id) {
      state.loadedNuclei2 = state.loadedNuclei2.filter(nucleus => {
        return nucleus.id !== id
      })
    },
    clearLoadedNuclei2 (state) {
      state.loadedNuclei2 = []
    }
  },
  actions: {
    loadNuclei2 ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedNuclei2', [])

      return new Promise((resolve, reject) => {
        HTTP.get('nucleus.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedNuclei2', result.data.results)
            commit('setLoading', false)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    createNucleus2 ({ commit, getters }, payload) {
      console.log('createNucleus2')
      commit('clearError')
      commit('setLoading', true)
      const newNucleus2 = {
        description: payload.description,
        ownship: {
          id: payload.ownship.id
        }
      }
      console.log('newNucleus2', newNucleus2)
      return new Promise((resolve, reject) => {
        HTTP.post('nucleus.json/', newNucleus2)
          .then(result => {
            console.log(result)
            commit('createNucleus2', result.data)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log('estou no erro aqui')
            console.log(err.data)
            console.log(err.statusText)
            console.log(err.status)
            console.log('meu erro aqui', err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    updateNucleus2 ({ commit, getters }, payload) {
      console.log('updateNucleus2')
      commit('clearError')
      commit('setLoading', true)
      const nucleus = {
        description: payload.description,
        ownship: {
          id: payload.ownship.id
        }
      }
      console.log('nucleus', nucleus)
      return new Promise((resolve, reject) => {
        HTTP.patch(`nucleus.json/${payload.id}/`, nucleus)
          .then(result => {
            console.log(result)
            commit('updateNucleus2', result.data)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    removeNucleus2 ({ commit }, payload) {
      console.log('removeNucleus2')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`nucleus.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeNucleus2', payload)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    clearLoadedNuclei2 ({ commit }) {
      commit('clearLoadedNuclei2')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/nucleus2/index.js